export enum CustomPacingScheduleDropdownButtonLabel {
  SET_SCHEDULE = 'Set Schedule',
  REMOVE_SCHEDULE = 'Remove Schedule',
}

export enum CustomPacingScheduleDropdownButtonAriaLabel {
  SET_SCHEDULE = 'Set Custom Pacing Schedule',
  REMOVE_SCHEDULE = 'Remove Custom Pacing Schedule',
}

type TooltipProps = {
  id: string;
  message: string;
  isDisabled?: boolean;
};

export type CustomPacingPacingScheduleDropdownButtonConfig = {
  id: number;
  label: CustomPacingScheduleDropdownButtonLabel;
  onClick: () => void;
  isDisabled?: boolean;
  ariaLabel?: CustomPacingScheduleDropdownButtonAriaLabel;
  dataTestId?: string;
  tooltipProps?: TooltipProps;
};
